// İSG uzmanı portalı — yönetim paneli kabuğu (S33 Slice 5, owner kararı — kabuk KENDİ
// Breadcrumb+PageHeader'ını taşır; `docs/plans/S33-carbon-reskin.md` Slice 5, `docs/BACKLOG.md`
// "known exception"ini kapatır). PageHeader'ın sağındaki birincil aksiyon o an AKTİF sekmenin
// kendisidir (`ShellHeaderAction` portal köprüsü — bkz. o dosyanın başlığı). Alt sayfalar (rol
// LİSTESİ, firma LİSTESİ, mobil app-link ayarı, kiosk cihazları) `Outlet` ile render edilir;
// `CompaniesPage`/`RolesPage`/`KioskDevicesPage` artık kendi yerel `<h2>`'sini TAŞIMAZ (kabuğun
// `<h1>`'i TEK gerçek başlık) — `AppSettingsPage` bu turda DOKUNULMADI (Slice 4'ün "list
// anatomy" kapsamına hiç girmemişti, kendi küçük `<h2>` başlığı kalır; `docs/BACKLOG.md`).
//
// **S33 Slice 6 owner kararı — DETAY sayfaları bu kabuğun Outlet'i DIŞINDA.** `router.tsx`'te
// bu bileşen artık `AdminGate`'in KENDİSİ değil, onun altında yol'suz (pathless) bir iç-içe
// layout rotası — yalnız YUKARIDAKİ liste sekmelerini sarar. `CompanyDetailPage`/
// `BranchDetailPage`/`RolePermissionsPage` (rol/firma/şube DETAYI) `AdminGate`'in DOĞRUDAN
// çocuklarıdır, bu kabuğun DEĞİL — kendi Breadcrumb ("Yönetim / <liste> / <ad>") +
// `PageHeader`'larını taşırlar (permit detail ile AYNI desen), çift başlık bloğu üretilmez.
// Yetki sondası (`AdminGate`) HER İKİ alt ağaç için de AYNI kalır — URL'ler değişmedi.

import { Breadcrumb, PageHeader } from '@isgportal/shared';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { RouteTabs } from '../../components/layout/RouteTabs';
import {
  ShellHeaderActionProvider,
  useShellHeaderActionSlot,
} from '../../components/layout/ShellHeaderAction';
import { useKioskAccess } from '../../lib/kioskAccess';

export function AdminShell() {
  const { t } = useTranslation();
  // "Kiosk Cihazları" sekmesi yalnız kiosk yetkisi (backend sondası) varsa görünür —
  // asıl yetki backend'de ([ModuleAction("kiosk", …)]); bu yalnız UX görünürlüğüdür.
  const kiosk = useKioskAccess();
  const { slotRef, slot } = useShellHeaderActionSlot();

  return (
    <div className="flex flex-col gap-6">
      <Breadcrumb items={[{ label: t('admin.nav') }]} />
      <PageHeader title={t('admin.nav')} helperText={t('admin.subtitle')} actions={slot} />
      {/* Sekme listesi + gövde ARASINDA boşluk YOK (S33 Slice 6 owner kararı, bkz.
          `SettingsShell.tsx`'in aynı notu). */}
      <div className="flex flex-col">
        <RouteTabs
          ariaLabel={t('admin.nav')}
          items={[
            { to: '/admin/roles', label: t('admin.tab.roles') },
            { to: '/admin/companies', label: t('admin.tab.companies') },
            // Mobil Uygulama Bağlantıları (§26) — global app-settings; yazma sistem adminidir
            // (`admin-app-settings/update`). Kabuk zaten sistem-admin sondasıyla korunur → sekme
            // koşulsuz (Yetki/Firma gibi); grant'sız principal buraya ulaşmaz.
            { to: '/admin/app-settings', label: t('admin.tab.appSettings') },
            ...(kiosk.status === 'granted'
              ? [{ to: '/admin/kiosk-devices', label: t('admin.tab.kiosk') }]
              : []),
          ]}
        />
        <ShellHeaderActionProvider value={slotRef}>
          <Outlet />
        </ShellHeaderActionProvider>
      </div>
    </div>
  );
}
